/**
 * Pages accessibles sans être connecté.
 *
 * Trois endroits en dépendent : le garde du routeur, l'intercepteur 401 et
 * le chargement du profil au démarrage. Les garder synchronisés à la main
 * a déjà provoqué une redirection vers /login depuis le lien de
 * réinitialisation de mot de passe — la liste vit donc ici, à un seul endroit.
 */
export const PAGES_PUBLIQUES = [
  "/login",
  "/register",
  "/forgot-password",
  "/reset-password",
];

/** Le chemin donné est-il accessible sans session ? */
export function estPagePublique(chemin) {
  return PAGES_PUBLIQUES.indexOf(chemin) !== -1;
}
